// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2FbHw","row":"styles_row__13qSf","identifier":"styles_identifier__1nKkj"};